import { render, staticRenderFns } from "./firstPage.vue?vue&type=template&id=29ae1188"
import script from "./firstPage.vue?vue&type=script&lang=js"
export * from "./firstPage.vue?vue&type=script&lang=js"
import style0 from "./firstPage.vue?vue&type=style&index=0&id=29ae1188&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports